import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { toast, Bounce } from 'react-toastify';

import history from '~/services/history';

import { toggleDisableButton } from '~/store/modules/disableButtons/actions';
import { signInRequest } from '~/store/modules/auth/actions';

import { Body, Container, Formulario, ThisColoredButton, Footer } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ThisFormElements from './ThisFormElements';
import AvisoNovoPortal from '~/componentes/AvisoNovoPortal';
import LogoErpWorks from '~/assets/logos/Logo ErpWorks Engrenagem Dark.svg';
import { useSelector } from 'react-redux';

function ToastLogin({ message }) {
  return (
    <div>
      <p
        style={{
          fontSize: '1.3rem',
          color: '#FFF',
        }}
      >
        Erro ao realizar login!
      </p>
      <p style={{ fontSize: '0.9rem', color: '#FFF' }}>
        Verifique seu e-mail e senha, ou entre em contato com o suporte.
      </p>
      <p style={{ fontSize: '0.9rem', color: '#FFF' }}>Mensagem da requisição: {message} </p>
    </div>
  );
}

export default function Entrar() {
  const dispatch = useDispatch();
  const [params, setParams] = React.useState();
  const [logged, setLogged] = React.useState();
  const location = history?.location;
  const navigate = useNavigate();
  const logado = useSelector(state => state.auth.logado);

  React.useEffect(() => {
    if (logged) {
      toast.error(<ToastLogin message={logged.message} />, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
        transition: Bounce,
        style: {
          width: '600px',
          fontSize: '16px',
        },
      });
    }
  }, [logged]);

  React.useEffect(() => {
    if (logado) {
      navigate('/plataforma');
    }
  }, [logado]);

  React.useEffect(() => {
    if (!params && location?.search) {
      try {
        const handledParams = Object.fromEntries(new URLSearchParams(location.search));
        const { senhaToken, email } = handledParams || {};

        if (senhaToken && email) {
          setParams({ senhaToken, email });
        } else {
          throw new Error();
        }
      } catch {
        setParams({ failed: true });
      }
    }
  }, [location, params]);

  async function handleLogin({ email, senha }) {
    dispatch(toggleDisableButton());
    try {
      const dispatchSignIn = dispatch(
        signInRequest(email?.trim(), senha?.trim(), undefined, setLogged, navigate),
      );
      dispatch(toggleDisableButton());
    } catch {
      dispatch(toggleDisableButton());
    }
  }

  return (
    <>
      <Body>
        <AvisoNovoPortal />
        <Container>
          <img className={'login-logo'} src={LogoErpWorks} alt="LogoErpWorks" />
          <p className="titulo">Bem-vindo Novo</p>
          <Formulario className="login-form" onSubmit={handleLogin}>
            <div className="form-login">
              <ThisFormElements />

              <Materialize>
                <div className="row">
                  <div className="botao col s12 m12 l12">
                    <ThisColoredButton type="submit" blueLayout>
                      Entrar
                    </ThisColoredButton>
                  </div>
                </div>
              </Materialize>
            </div>
          </Formulario>
        </Container>
        {/* <Footer>
          <p className="text-direitos">Erpworks {new Date().getFullYear()} - Todos os direitos reservados</p>
        </Footer> */}
      </Body>
    </>
  );
}
